import React, {Component} from 'react';
import { NavLink } from 'react-router-dom';
import './Header.css';

export default class Header extends Component {
    state = {
        isMobileMenuOpen: false
    }

    toggleMobileMenu = () => {
        if(window.innerWidth > 999) return false;
        this.setState({
            isMobileMenuOpen: !this.state.isMobileMenuOpen
        });
    }

    render() {
        return (
            <header className="header">
                <div className="header__logo-botao-menu-wrap">
                    <button onClick={this.toggleMobileMenu} className="header__botao-mobile-menu"></button>
                    <NavLink to="/" className="header__logo" exact>Home</NavLink>
                </div>

                <nav className={this.state.isMobileMenuOpen ? 'header__nav header__nav--visible' : 'header__nav'}>
                    <button onClick={this.toggleMobileMenu} className="header__nav-botao-fechar"></button>
                    <NavLink onClick={this.toggleMobileMenu} className="header__nav-item" to="/" exact >Home</NavLink>
                    <NavLink onClick={this.toggleMobileMenu} className="header__nav-item" to="/quem-somos">Quem Somos</NavLink>
                    <NavLink onClick={this.toggleMobileMenu} className="header__nav-item" to="/consultoria-financeira">Consultoria Financeira</NavLink>
                    <NavLink onClick={this.toggleMobileMenu} className="header__nav-item" to="/consultoria-estrategica">Consultoria Estratégica</NavLink>
                    <NavLink onClick={this.toggleMobileMenu} className="header__nav-item" to="/contato">Contato</NavLink>
                </nav>
            </header>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Header.js